export var AgritaskEnv;
(function (AgritaskEnv) {
    AgritaskEnv["Development"] = "development";
    AgritaskEnv["FeatureTestInstance"] = "feature-test-instance";
    AgritaskEnv["Test01"] = "test01";
    AgritaskEnv["Test02"] = "test02";
    AgritaskEnv["Test03"] = "test03";
    AgritaskEnv["Test04"] = "test04";
    AgritaskEnv["Production"] = "production";
})(AgritaskEnv || (AgritaskEnv = {}));
const getAgritaskEnvFromUrl = (url = window?.location.href) => {
    if (!url) {
        return undefined;
    }
    const Url = new URL(url);
    if (Url.host.includes('agritask.xyz')) {
        return AgritaskEnv.FeatureTestInstance;
    }
    if (Url.host.includes('test.pescout.com')) {
        return AgritaskEnv.Test01;
    }
    if (Url.host.includes('support.pescout.com')) {
        return AgritaskEnv.Test03;
    }
    if (Url.host.includes('uat.pescout.com')) {
        return AgritaskEnv.Test04;
    }
    if (Url.host.includes('pescout.com')) {
        // Comes on purpose after test01 & test03
        return AgritaskEnv.Test02;
    }
    if (Url.host.includes('agritask.com')) {
        return AgritaskEnv.Production;
    }
    return AgritaskEnv.Development;
};
export default getAgritaskEnvFromUrl;
